import * as React from 'react'

import { useOwnerWalletList } from './hooks'
import { OwnerWallet } from './types'
import { CButton, CCardBody, CCol, CForm, CFormInput, CRow } from '@coreui/react-pro'
import { Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { setDecryptionPassword, submitEncodingPassword } from "./model";

export const OwnerWalletList = () => {
  const {
    ownerWallets,
    loading,
    decryptionPassword,
    showPasswordSection,
    passwordIncorrect,
  } = useOwnerWalletList()

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    let key = event.currentTarget.name
    let value = event.currentTarget.value
    setDecryptionPassword({...decryptionPassword, [key]:value })
  }

  const columns: ColumnsType<OwnerWallet> = [
    {
      title: 'Address',
      dataIndex: 'address',
    },
    {
      title: 'Password correct',
      dataIndex: 'isPrivateKeyDecrypted',
      render: (item: boolean) => (
        <>
          <Tag color={item === true ? '#2eb85c' : '#ff0000'}>{item === true ? 'Yes' : 'No'}</Tag>
        </>
      ),
    },
  ]

  return (
    <CCardBody>
     <div>
       {showPasswordSection && (
         <CForm>
           <CRow className="mb-3">
             <CCol sm={6}>
             <CFormInput
               type="password"
               id="password"
               name="password"
               value={decryptionPassword.password}
               onChange={handleChange}
               onKeyDown={(e) => {
                 if (e.key === 'Enter') {
                   e.preventDefault();
                 }
               }}
               label="Decryption password:"
             />
             </CCol>
           </CRow>
           {passwordIncorrect && (
             <CRow className="mb-3">
               <CCol sm={6}>
                 <Tag color='#ff0000'>Wrong password</Tag>
               </CCol>
             </CRow>
           )}
           <CRow className="mb-3">
             <CCol sm={6}>
             <CButton
               className="mb-3"
               disabled={loading}
               onClick={() => submitEncodingPassword(decryptionPassword)}
             >
               {loading && (
                 <span className="spinner-border spinner-border-sm"></span>
               )}
               Set encoding password
             </CButton>
             </CCol>
           </CRow>


         </CForm>
         // </div>
       )}
     </div>

      <Table
        dataSource={ownerWallets}
        bordered={true}
        scroll={{x: true}}
        loading={loading}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
            },
          }
        }}
        rowKey="address"
        columns={columns}
        pagination={false}
      />
    </CCardBody>
  )
}
